import { render, staticRenderFns } from "./IconInterest.vue?vue&type=template&id=1ce92d9e&scoped=true&"
var script = {}
import style0 from "./IconInterest.vue?vue&type=style&index=0&id=1ce92d9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce92d9e",
  null
  
)

export default component.exports